(() => {
  'use strict';
  const body = document.body;
  if (body.classList.contains('objectiv-homepage')) return;
  const phone = matchMedia('(max-width: 749px), (max-width: 989px) and (max-height: 500px)');
  const viewport = window.visualViewport;
  let frame;

  function measure() {
    frame = null;
    if (!phone.matches) {
      body.style.removeProperty('--obj-page-visible-height');
      return;
    }
    // Pinch zoom changes the visual viewport without changing page layout.
    if (viewport && Math.abs(viewport.scale - 1) > .01) return;
    // This smaller measurement is for fitting controls/dialogs only. Page
    // surfaces use CSS large viewport units so Safari's bottom region is painted.
    const height = Math.min(innerHeight, viewport?.height || innerHeight);
    if (height > 0) body.style.setProperty('--obj-page-visible-height', `${height}px`);
  }

  function schedule() {
    if (frame == null) frame = requestAnimationFrame(measure);
  }
  addEventListener('resize', schedule, {passive: true});
  addEventListener('pageshow', schedule);
  viewport?.addEventListener('resize', schedule, {passive: true});
  phone.addEventListener('change', schedule);
  measure();
})();
